export const RESERVED_VIEWPORT_HEIGHT_DESKTOP = 100;
export const RESERVED_VIEWPORT_HEIGHT_MOBILE = 200;

export const getReservedViewportHeight = (): number => {
  if (typeof window === 'undefined') return RESERVED_VIEWPORT_HEIGHT_DESKTOP;
  const isMobile = window.innerWidth < 768 || 'ontouchstart' in window;
  return isMobile ? RESERVED_VIEWPORT_HEIGHT_MOBILE : RESERVED_VIEWPORT_HEIGHT_DESKTOP;
};
